module.exports = __webpack_public_path__ + "img/overview_left_sex_male.1d510c75.png";